import { Icon, IconProps } from "../";

export const CheckIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.66351 10.5418C5.00522 10.2001 5.55924 10.2001 5.90094 10.5418L10.232 14.1605L18.0985 7.00628C18.4402 6.66457 18.9943 6.66457 19.336 7.00628C19.6777 7.34799 19.6777 7.90201 19.336 8.24372L10.8507 16.729C10.509 17.0707 9.95496 17.0707 9.61326 16.729L4.66351 11.7793C4.3218 11.4375 4.3218 10.8835 4.66351 10.5418Z"
      />
    </Icon>
  );
};
